interface IProps {
  isClicked: boolean;
}

export const CalendarIcon = ({ isClicked }: IProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="30"
      viewBox="0 0 26 30"
      fill="none"
    >
      <path
        d="M22.8931 3.59846H21.4679V0.748047H18.6175V3.59846H7.21587V0.748047H4.36546V3.59846H2.94025C1.35828 3.59846 0.104096 4.88114 0.104096 6.44887L0.0898438 26.4017C0.0898438 27.9695 1.35828 29.2521 2.94025 29.2521H22.8931C24.4608 29.2521 25.7435 27.9695 25.7435 26.4017V6.44887C25.7435 4.88114 24.4608 3.59846 22.8931 3.59846ZM22.8931 26.4017H2.94025V12.1497H22.8931V26.4017ZM22.8931 9.29928H2.94025V6.44887H22.8931V9.29928ZM8.64107 17.8505H5.79066V15.0001H8.64107V17.8505ZM14.3419 17.8505H11.4915V15.0001H14.3419V17.8505ZM20.0427 17.8505H17.1923V15.0001H20.0427V17.8505ZM8.64107 23.5513H5.79066V20.7009H8.64107V23.5513ZM14.3419 23.5513H11.4915V20.7009H14.3419V23.5513ZM20.0427 23.5513H17.1923V20.7009H20.0427V23.5513Z"
        fill={isClicked ? "#fff" : "#004A80"}
      />
    </svg>
  );
};
